import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { API_ROUTES } from "@/services/environment";
import { useAppSelector } from "@/hooks/hook";
import { useEffect, useState } from "react";
import { GET, POST } from "@/services/api";
import Lottie from "lottie-react";
import { Button } from "@thdinc/hpf-shared";

interface Product {
  id: string;
  name: string;
  description: string;
  prices: Price[];
}

interface Price {
  id: string;
  currency: string;
  amount: number;
  interval: string;
}


interface StripeCardModalProps {
  clientSecret: string;
  isLoading: boolean;
  onSave: (paymentMethodId: string, productId?: string, priceId?: string) => void;
}

export const StripeCardModal: React.FC<StripeCardModalProps> = ({
  clientSecret,
  onSave,
  isLoading
}) => {
  const stripe = useStripe();
  const elements = useElements();

  const user = useAppSelector((store) => store.user);
  const { getProductDetailApi } = API_ROUTES;
  const [isCardComplete, setIsCardComplete] = useState(false);
  const [stripeError, setStripeError] = useState<string | null>(null)
  const [productDetail, setProductDetail] = useState<Product | null>(null)
  // Handle save stripe card
  const handleSubmit = async (event: React.FormEvent) => {
    try {
      event.preventDefault();
      if (!stripe || !elements) {
        console.error("Stripe.js not loaded");
        return;
      }

      const cardElement = elements.getElement(CardElement);
      if (!cardElement) {
        console.error("CardElement not found");
        return;
      }

      const { setupIntent, error } = await stripe.confirmCardSetup(clientSecret, {
        payment_method: { card: cardElement },
      });

      if (error) {
        setStripeError(error.message as string)
      } else if (setupIntent?.payment_method) {
        onSave(setupIntent.payment_method as string, productDetail?.id, productDetail?.prices[0].id);
        setStripeError(null)

      }
    } catch (error) {
      console.log(error)
    }
  };
  useEffect(() => {
    const GetProductDetail = async () => {
      const res = await GET(getProductDetailApi, user.refreshToken)
      setProductDetail(res.data[0])
    }
    GetProductDetail()
  }, [])
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="min-h-20 font-semibold relative">
          {productDetail && !user.card && <div>

            <p>Title : <span className="text-gray-500">{productDetail?.name}</span> </p>
            <p>Description : <span className="text-gray-500">{productDetail?.description}</span> </p>
            <p>Fee : <span className="text-gray-500">${productDetail?.prices[0]?.amount / 100}</span> </p>
          </div>}
          <CardElement
            onChange={(event) => setIsCardComplete(event.complete)}
            options={{
              hidePostalCode: true,
              style: {
                base: {
                  color: "#4a4a4a",
                  fontSize: "20px", // Increase font size for better visibility
                  fontFamily: '"Arial", sans-serif',
                  lineHeight: "2.5", // Adjust height
                  "::placeholder": {
                    color: "#a0aec0",
                    fontSize: "16px", // Adjust placeholder size
                  },
                },
                invalid: {
                  color: "#fa755a",
                  iconColor: "#fa755a",
                },
              },
            }}
          />
          {stripeError && <p className="text-primary-red text-sm font-normal">{stripeError}</p>}
        </div>
        <div className="flex justify-end">
          <Button
            className={`${!stripe || !elements || !isCardComplete ? "bg-gray-300 text-gray-500  " : "bg-primary-red text-white"
              }  px-5 py-2 rounded-full text-sm font-semibold`}
            type="submit"
            disabled={!stripe || !elements || !isCardComplete || isLoading} // Disable button based on input state
          >
            {isLoading ? "Adding..." : "Add Card"}
          </Button>
        </div>
        {/* {animationVisibility && <div className="w-full absolute bottom-0 left-0">
          <Lottie
            style={{ height: '252px', width: '100%' }}
            animationData={require('../../assets/lottie/welcome.json')} loop={true} />
        </div>} */}
      </form>
    </div>
  );
};